import type { AttackerBlockBan, CardView } from "../api/types";

// Engine ships `illegal_blockers` as a default-yes veto list. The SPA
// reads it only here so we never re-implement keyword rules.

export function isBlockPairLegal(
  blocker: CardView,
  attackerId: number,
  illegalBlockers?: AttackerBlockBan[],
): boolean {
  if (blocker.type !== "creature") return false;
  if (!illegalBlockers) return true;
  for (const ban of illegalBlockers) {
    if (ban.attacker !== attackerId) continue;
    return !ban.blockers.includes(blocker.entity_id);
  }
  return true;
}

/** True iff `blocker` can block at least one of `attackers`. */
export function canBlockAny(
  blocker: CardView,
  attackers: number[],
  illegalBlockers?: AttackerBlockBan[],
): boolean {
  if (blocker.type !== "creature") return false;
  return attackers.some((aid) => isBlockPairLegal(blocker, aid, illegalBlockers));
}
